<template lang="pug">
.colorNames(:style="{backgroundColor:currentColor.value}")
  h1.h4(:style="{color: this.colorVal.hsl.l > 0.5 ? '#000' : '#fff'}") {{currentColor.name}}
  no-ssr
    chrome-picker(v-model="colorVal" @input="updateColor" disableAlpha)

</template>

<script>
import { generateSeoMeta } from '~/utils/seo';
import { Chrome } from 'vue-color';
import nearestColor from 'nearest-color';
import allColors from '~/assets/data/colornames.json';

let map = {};
allColors.forEach(function(entry) {
  map[entry.name] = entry.hex;
});
let nc = nearestColor.from(map);

let components = {
  'chrome-picker': Chrome
};
export default {
  layout: 'minimal',

  head: generateSeoMeta({ title: 'pageTitle', description: 'pageDesc' }, { i18n: true }),
  components: components,
  data: () => ({
    colorVal: {
      hsl: { h: 231.61572052401746, s: 1, l: 0.5509803921568628, a: 1 },
      hex: '#1A3AFF',
      hex8: '#1A3AFFFF',
      rgba: { r: 26, g: 58, b: 255, a: 1 },
      hsv: { h: 231.61572052401746, s: 0.8980392156862745, v: 1, a: 1 },
      oldHue: 60,
      source: 'hex',
      a: 1
    },
    currentColor: {
      value: '#1A3AFF',
      name: 'Vivid Blue'
    }
  }),
  mounted() {},
  methods: {
    updateColor() {
      this.currentColor = nc(this.colorVal.hex);
    }
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Color name",
    "pageDesc":"Test your color combinations and palettes. Calculate the contrast ratio to give your design depth and personality."
  },
  "ar": {
    "pageTitle":"اسم اللون",
    "pageDesc":"اختبر تركيبات الألوان واحسب التباين لإعطاء عمق للتصميم والشخصية من خلال الظلال وامنح تصميمك الروح واجعلها نابضة بالحياة"
  }
}
</i18n>

<style lang="stylus">
.colorNames
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  display: flex
  align-items: center
  align-items: center
  justify-content: center
  flex-direction: column
  color: $clWhite
</style>
